module.exports = __webpack_public_path__ + "img/1583980506.c430a289.jpg";